import { render } from "./MenuDropdown.vue?vue&type=template&id=3824078f&ts=true"
import script from "./MenuDropdown.vue?vue&type=script&lang=ts"
export * from "./MenuDropdown.vue?vue&type=script&lang=ts"

import "./MenuDropdown.vue?vue&type=style&index=0&id=3824078f&lang=css"

import exportComponent from "/Users/camp2/Devs/pontuei/pontuei-painel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__